import { c as _c } from "react/compiler-runtime";
import './streambot.css';
import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';
import WithMSWProvider from '@/mocks/apiV4/WithMSWProvider';
export type StreambotWrapperProps = {
  children?: ReactNode;
  className?: string;
  textAlign?: string;
  overflow?: string;
};
function StreambotWrapper(t0) {
  const $ = _c(9);
  const {
    children,
    className,
    textAlign,
    overflow
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("wrapper", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== overflow || $[3] !== textAlign) {
    t2 = {
      "--streambot-text-align": textAlign,
      "--streambot-overflow": overflow
    };
    $[2] = overflow;
    $[3] = textAlign;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = t2 as CSSProperties;
  let t4;
  if ($[5] !== children || $[6] !== t1 || $[7] !== t3) {
    t4 = <div className={t1} style={t3}>{children}</div>;
    $[5] = children;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export default WithMSWProvider(StreambotWrapper);